module.exports = __webpack_public_path__ + "static/media/Creative for JA Blog - 27.06.23.ea2b2e57.jpg";